import React, { memo } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { Image } from 'expo-image';
import { Promotion } from '@/data/types';
import { colors, radius, shadows, spacing, type, useAppTheme } from '@/theme';
import { ScaledSheet } from '@/theme/responsive';

interface Props {
  promotion: Promotion;
  onPress?: () => void;
}

function PromotionCardComponent({ promotion, onPress }: Props) {
  const { colors } = useAppTheme();

  return (
    <Pressable accessibilityRole="button" onPress={onPress} style={[styles.card, { backgroundColor: colors.surface }]}>
      <Image source={{ uri: promotion.image }} style={StyleSheet.absoluteFill} contentFit="cover" transition={150} />
      <View style={styles.scrim} />
      <View style={[styles.discountPill, { backgroundColor: colors.accentFill }]}>
        <Text style={[styles.discountText, { color: colors.white }]}>{promotion.discountLabel}</Text>
      </View>
      <View style={styles.body}>
        <Text style={[type.titleLg, styles.title]} numberOfLines={1}>{promotion.title}</Text>
        {promotion.expiresAt && (
          <Text style={[type.caption, styles.expiry]}>Expires {new Date(promotion.expiresAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</Text>
        )}
      </View>
    </Pressable>
  );
}

export const PromotionCard = memo(PromotionCardComponent);

const styles = ScaledSheet.create({
  card: { width: 260, height: 130, borderRadius: radius.lg, overflow: 'hidden', backgroundColor: colors.surface, ...shadows.card },
  scrim: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: colors.overlay },
  discountPill: {
    position: 'absolute',
    top: spacing.md,
    left: spacing.md,
    backgroundColor: colors.accentFill,
    paddingHorizontal: spacing.sm,
    paddingVertical: 4,
    borderRadius: radius.xs,
  },
  discountText: { fontSize: 11, fontWeight: '800', color: colors.white, letterSpacing: 0.4 },
  body: { position: 'absolute', left: spacing.md, right: spacing.md, bottom: spacing.md, gap: 2 },
  title: { color: colors.textOnDark },
  expiry: { color: colors.textOnDarkSecondary },
});
